import apiClient from './apiClient';
import type { Client, CreateClientRequest } from '../types/project';

export const getClients = async (): Promise<Client[]> => {
  const response = await apiClient.get<Client[]>('/clients');
  return response.data;
};

export const getClient = async (clientKey: string): Promise<Client> => {
  const response = await apiClient.get<Client>(`/clients/${clientKey}`);
  return response.data;
};

export const createClient = async (data: CreateClientRequest): Promise<Client> => {
  const response = await apiClient.post<Client>('/clients', data);
  return response.data;
};

export const updateClient = async (clientKey: string, data: Partial<CreateClientRequest>): Promise<Client> => {
  const response = await apiClient.put<Client>(`/clients/${clientKey}`, data);
  return response.data;
};

export const deleteClient = async (clientKey: string): Promise<void> => {
  await apiClient.delete(`/clients/${clientKey}`);
};
